import { Select } from "antd";
import { FC, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { getAllStudentClasses, getStudentClasses } from '../../../api/mypage.api';
import useAxios from "../../../hooks/useAxios";
import { IGetStudentClasses } from "../../../models/mypage.model";
import ErrorResponse from "../../ErrorResponse";
import Loader from "../../Loader";

interface IProps {
  memberCode: string|undefined;
  classCode: string|undefined;
  setClassCode: (classCode: string) => void;
  isAll?: boolean;
}

const SelectStudentClass: FC<IProps> = ({
  memberCode,
  classCode,
  setClassCode,
  isAll = false
}) => {
  const { data: res, isLoading, error, execute } = useAxios<IGetStudentClasses>();
  const { t } = useTranslation();

  useEffect(() => {
    if (memberCode) {
      if (isAll) {
        execute(getAllStudentClasses(memberCode));
        return;
      }

      execute(getStudentClasses(memberCode));
    }
  }, [memberCode, isAll]);

  return (
    <>
      {isLoading && <Loader />}
      <ErrorResponse error={error} />

      <Select
        className="w-100"
        placeholder={t('student.student.column23')}
        value={classCode}
        onChange={value => setClassCode(value)}
        style={{minWidth: 200}}
      >
        {res?.data?.map((item: any, index: number) => {
          return (
            <Select.Option
              key={index}
              value={item.classCode}
            >
              ({item.semesterName}) {item.className}
            </Select.Option>
          )
        })}
      </Select>
    </>
  );
}

export default SelectStudentClass;
